import RestClient from '../restClient';

class UserEntityConytoller {
  static getCurrentUser() {
    return RestClient.getAxios(`/keycloak/current-user`);
  }
}
export default UserEntityConytoller;
